import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../stores/actionsList';
import HttpServices from "../../../utils/Http.services";
import SidebarView from "../../SidebarView";
import StagesManager from "../../StagesManager";
import MainMessengerControl from "./create/MainMessengerControl";
import CreateGroup from "./sideBar/CreateGroup";
import ProceedFrameSelector from "./create/ProceedFrameSelector";

class MessengerCreateNew extends Component {

    state = {
        data: [],
        isLoader: false,
        filteredContacts: [],
        isLoading: false
    }

    componentDidMount() {
        // this.fetchContacts()
    }

    openSidebar = () => {
        // this.fetchContacts()
        this.sidebarView.openSidebar()
    }

    closeSidebar = () => {
        this.sidebarView.closeSidebar()
    }



    searchHub = (event) => {
        this.setState({ listSearch: event.target.value }, () => {
            let contactsList = this.state.contactsList
            let filteredContacts = contactsList?.filter((e) => {
                if (e.hub) {
                    let hub = e.hub
                    if (hub.fullname && hub.fullname.toLowerCase().includes(this.state.listSearch.toLowerCase())) {
                        return hub.fullname.toLowerCase().includes(this.state.listSearch.toLowerCase())
                    }
                    else if (hub.username && hub.username.toLowerCase().includes(this.state.listSearch.toLowerCase())) {
                        return hub.username.toLowerCase().includes(this.state.listSearch.toLowerCase())
                    }
                }
            })
            this.setState({ filteredContacts })
        })
    }

    openOne = (item, frame) => {
        this.props.openOne(item, frame, this.state.selectedScope)
        this.sidebarView.closeSidebar()
    }

    changeStage = (key) => {
        this.stageManager.changeStage([key])
    }


    createGroup = (data) => {
        console.log('*createGroup(')
        this.setState({ isLoader: true, isLoading: true })

        // data.frames.push(this.state.selectedScope)
        data.myFrame = this.state.selectedScope?._id

        console.log(data)

        HttpServices.request('createGroupMessenger', data, (fetchResult, fetchError) => {
            // console.log('fetchErrorCG',fetchError)
            if (fetchError) {
                return
            }
            if (fetchResult.info) {
                let name = fetchResult.info?.name
                fetchResult.info["**name"] = name
                let messenger = fetchResult.info
                if (!Array.isArray(messenger)) {
                    messenger = [messenger]
                }
                this.props.actions.addMessengers(messenger)
                setTimeout(() => {
                    this.props.setMessenger(fetchResult.info, () => {
                        this.sidebarView.closeSidebar()
                        this.setState({ isLoader: false, isLoading: false })
                    })
                }, 50);
            } else {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.failedToSendDate', description: "Failed" })
            }
        })
    }

    functionsHandler = (type, name, data, extra) => {

        if (this[name]) {
            this[name](data, extra)
        }

    }

    changeScope = (data) => {

        this.setState({ selectedScope: data.item }, () => {

            this.stageManager.changeStage('mainControl')

        })
    }


    render() {
        return (
            <SidebarView width={this.props.width} isDesktop={this.props.isDesktop} ref={el => this.sidebarView = el} sideOpen={false} hideOverlay={false} widthCondition={{ xs: "calc(100% - 50px)", sm: "calc(100% - 50px)", md: '35%', lg: "35%", xl: "30%" }}>
                <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}>

                    <ProceedFrameSelector isDesktop={this.props.isDesktop} type={"messenger"} changeScope={this.changeScope} functionsHandler={this.functionsHandler} closeSidebar={this.closeSidebar} language={this.props.language} isApplet={this.props.isApplet} stage={0} stageName={'frameSelector'} width={this.props.width}
                        openSidebar={this.openSidebar} fetchContacts={this.fetchContacts} openOne={this.openOne} changeStage={this.changeStage} contactsList={this.state.contactsList} filteredContacts={this.state.filteredContacts} listSearch={this.state.listSearch} searchHub={this.searchHub} colors={this.props.colors} />

                    <MainMessengerControl isDesktop={this.props.isDesktop} closeSidebar={this.closeSidebar} language={this.props.language} isApplet={this.props.isApplet} stage={1} stageName={'mainControl'} width={this.props.width}
                        openSidebar={this.openSidebar} fetchContacts={this.fetchContacts} openOne={this.openOne} changeStage={this.changeStage} contactsList={this.state.contactsList} filteredContacts={this.state.filteredContacts} listSearch={this.state.listSearch} searchHub={this.searchHub} colors={this.props.colors} />
                    <CreateGroup isDesktop={this.props.isDesktop} language={this.props.language} isLoading={this.state.isLoading} isLoader={this.state.isLoader} openModal={this.props.openModal} variables={this.props.variables} setData={this.props.setData} myId={this.props.myId} stage={1} stageName={'createGroup'} width={this.props.width} createGroup={this.createGroup} colors={this.props.colors} />
                    {/* <CreateSupport stage={2} stageName={'createSupport'} width={this.props.width} createGroup={this.createGroup} /> */}
                </StagesManager>
            </SidebarView>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, messengers: state.messengers })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(MessengerCreateNew);